/* eslint import/prefer-default-export: 0 */

import remote from './remote';

export function getSports(query = {}) {
  return remote.get('categories', query);
}
